import { supabase } from './supabase';

export async function getSubscriptionStatus() {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user?.email) {
      throw new Error('Not authenticated');
    }

    const { data: subscription, error } = await supabase
      .from('subscriptions')
      .select('*')
      .eq('user_email', session.user.email)
      .eq('status', 'active')
      .single();

    if (error) throw error;
    return subscription;
  } catch (error) {
    console.error('Error fetching subscription:', error);
    return null;
  }
}

export async function verifyCheckoutSession(sessionId: string) {
  try {
    const { data, error } = await supabase.functions.invoke('verify-subscription', {
      body: { session_id: sessionId }
    });

    if (error) throw error;
    return data.subscription;
  } catch (error) {
    console.error('Error verifying session:', error);
    return null;
  }
}

export async function cancelSubscription() {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user?.email) {
      throw new Error('Not authenticated');
    }

    const { error } = await supabase.functions.invoke('cancel-subscription', {
      body: { userEmail: session.user.email }
    });

    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Error canceling subscription:', error);
    throw error;
  }
}

export async function updateSubscription(newPriceId: string) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user?.email) {
      throw new Error('Not authenticated');
    }

    const { error } = await supabase.functions.invoke('update-subscription', {
      body: { 
        userEmail: session.user.email,
        newPriceId
      }
    });

    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Error updating subscription:', error);
    throw error;
  }
}